import { render, staticRenderFns } from "./Verka_Geo_Pin_Pos.vue?vue&type=template&id=6863aa52&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports